import { useState } from "react";
import { useLocation, useNavigate, useOutlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaBars, FaSignOutAlt } from "react-icons/fa";
import { logoutUser } from "../../../slices/auth/authenticationSlice";
import { getLmsDashboardCopy } from "../utils/lmsDashboardContent";
import { getLmsRole } from "../utils/lmsRole";
import LmsSidebar from "../components/LmsSidebar";
import LmsDashboardHome from "../components/LmsDashboardHome";
import ContentLibraryPage from "../content/pages/ContentLibraryPage";
import AssignmentManagementPage from "../assignments/pages/AssignmentManagementPage";
import ReportsOverviewPage from "../reports/pages/ReportsOverviewPage";
import { LmsDashboardWrapper } from "../styles/LmsDashboardStyle";

const LmsDashboardPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { credObj } = useSelector((store) => store.auth);
  const { currentUser } = useSelector((store) => store.users);
  const role = getLmsRole({ currentUser, credObj });
  const copy = getLmsDashboardCopy(role);
  const location = useLocation();
  const outlet = useOutlet();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate("/lms/login", { replace: true });
  };

  const renderFallback = () => {
    const path = location.pathname;
    if (path.endsWith("/library")) {
      return <ContentLibraryPage />;
    }
    if (path.endsWith("/assignments")) {
      return <AssignmentManagementPage />;
    }
    if (path.endsWith("/reports")) {
      return <ReportsOverviewPage />;
    }
    return <LmsDashboardHome role={role} />;
  };

  return (
    <LmsDashboardWrapper>
      <LmsSidebar
        role={role}
        isOpen={isSidebarOpen}
        onNavigate={() => setIsSidebarOpen(false)}
      />
      <div className="lms-dashboard-shell">
        <header className="lms-topbar">
          <button
            type="button"
            className="lms-icon-button"
            aria-label="Open navigation"
            onClick={() => setIsSidebarOpen((current) => !current)}
          >
            <FaBars />
          </button>
          <div>
            <span>{copy.audienceLabel}</span>
            <strong>{currentUser?.name || currentUser?.email || "ReadRivals member"}</strong>
          </div>
          <button type="button" className="lms-logout" onClick={handleLogout}>
            <FaSignOutAlt aria-hidden="true" />
            <span>Logout</span>
          </button>
        </header>
        <main className="lms-dashboard-content">
          {outlet || renderFallback()}
        </main>
      </div>
    </LmsDashboardWrapper>
  );
};

export default LmsDashboardPage;
